<script>
  import QrCode from "svelte-qrcode"
  /**
   * @type {string}
   */
  export let reps;
  export let headers;
  import { __ } from '../../utils/i18n';

  // console.log(reps)

  const phoneNumber = (d) => {
  // removes anything that's not a digit from the phone number
  return String(d).replace(/\D/g, '');
};

  const dashedPhoneNumber = (d) => {
    // following ap style, returns xxx-xxx-xxxx
    // just in case, remove everything that is not a number first
    let cleanNumber = String(d).replace(/\D/g, '');
    let formattedNumber =
      '(' +
      cleanNumber.slice(0, 3) +
      ') ' +
      cleanNumber.slice(3, 6) +
      '-' +
      cleanNumber.slice(6);
    return String(formattedNumber);
  };
</script>
<table class="reptable" id="that">
  {#if headers}
    {#each headers as header,i}
      <tr>
        <th colspan={i == 0 ? '2': '5'}>
            { __(header) }
        </th>
        {#if i == 0}
          <th colspan="1">
            { __("Phone") }
          </th>
          <th colspan="1">
            { __("Email or Website") }
          </th>
        {/if}
      </tr>
      {#if reps }
        {#each reps[i] as r}
        <tr>
          <td class="col1">
            { __(r.office) }
          </td>
          <td class="col2">
            <div class="flex">
              <span>
                {r.repname}
              </span>
            </div>
          </td>
          <td class="col3">
            {dashedPhoneNumber(r.phone)}<br/>
          </td>
          <td>
            {#if r.email }
            { r.email ? r.email : ''}
            {:else}
            <QrCode size=50 value="{r.site}" padding="2" />
            {/if}
          </td>
        </tr>
        {/each}
      {/if}
    {/each}
  {/if}
</table>